/* sm-maelingar.js (18.10.2026): stillisatburðir vörusíðna til greiningar (HONNUNARREGLUR M6).
   sm_config_start    fyrsta snerting við stilli (skref) á síðunni
   sm_config_step     fyrsta breyting í hverju skrefi (lykill og númer skrefs, ALDREI gildi eða texti viðskiptavinar)
   sm_preview_view    forskoðunin (aside[data-vs-svid]) hefur verið að minnsta kosti hálf sýnileg í 1 s
   sm_config_complete varan fór í körfu (sm:karfa með línu frá vélinni, eða sm:hurda-karfa ok)
   Sent með Shopify.analytics.publish, svo þeir ná AÐEINS til sérsniðins pixla (Customer events) sem hefur
   samþykki. Auk þess sendir skráin ekkert nema gestur hafi samþykkt greiningu (Shopify Customer Privacy API):
   án samþykkis gerist ekkert. Snertir engar vélaskrár: hlustar aðeins á DOM og atburði sem vélarnar senda nú þegar.
   Pixillinn sem sendir þá áfram í GA4 (505412989): yfirferd/seo-smatridi-2026-10-18/sm-config-pixill.js. */
(function () {
  'use strict';
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  var byrjad = false, sedForskodun = false, skrefSent = {};
  function leyft() {
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()); }
    catch (e) { return false; }
  }
  function senda(nafn, gogn) {
    if (!leyft()) return;
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') {
        var d = { product_handle: handle };
        for (var k in gogn) if (Object.prototype.hasOwnProperty.call(gogn, k)) d[k] = gogn[k];
        a.publish(nafn, d);
      }
    } catch (e) {}
  }
  function skrefUpplysingar(el) {
    var sk = el && el.closest ? el.closest('[data-vs-skref]') : null;
    if (!sk) return null;
    var allir = Array.prototype.slice.call(document.querySelectorAll('[data-vs-skref]'));
    return { step_key: sk.getAttribute('data-lykill') || '', step_type: sk.getAttribute('data-gerd') || '', step_number: allir.indexOf(sk) + 1 };
  }
  function snerting(e) {
    var u = skrefUpplysingar(e.target);
    if (!u) return;
    if (!byrjad) { byrjad = true; senda('sm_config_start', { step_key: u.step_key, step_number: u.step_number }); }
    if (e.type === 'click' && !(e.target.closest && e.target.closest('button, [role="radio"], label, input[type="radio"], input[type="checkbox"]'))) return;
    if (u.step_key && !skrefSent[u.step_key]) { skrefSent[u.step_key] = true; senda('sm_config_step', u); }
  }
  document.addEventListener('change', snerting, true);
  document.addEventListener('click', snerting, true);
  document.addEventListener('sm:karfa', function (e) {
    var d = (e && e.detail) || {};
    if (!('lina' in d)) return; /* sm-magnafslattur.js sendir líka sm:karfa, án línu */
    senda('sm_config_complete', { steps_changed: Object.keys(skrefSent).length });
  });
  document.addEventListener('sm:hurda-karfa', function (e) {
    if (e && e.detail && e.detail.ok) senda('sm_config_complete', { steps_changed: Object.keys(skrefSent).length });
  });
  function vaktaForskodun() {
    var el = document.querySelector('[data-vs-svid]');
    if (!el || !('IntersectionObserver' in window)) return;
    var timi = null;
    var io = new IntersectionObserver(function (f) {
      var synilegt = f[0] && f[0].intersectionRatio >= 0.5;
      if (synilegt && !timi && !sedForskodun) {
        timi = setTimeout(function () { sedForskodun = true; io.disconnect(); senda('sm_preview_view', {}); }, 1000);
      } else if (!synilegt && timi) { clearTimeout(timi); timi = null; }
    }, { threshold: [0, 0.5] });
    io.observe(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vaktaForskodun); else vaktaForskodun();
})();
